module.exports = __webpack_public_path__ + "images/blue-background.7fb2e5cec92c61e22bb173f67774a976.png";